import { useMemo } from 'react';
import useDatasetStore from '../store/datasetStore';
import { IDatasetBrief } from '../types/metadata';

export const useIsFwe = (datasetId?: string) => {
  const datasetBriefs = useDatasetStore((state) => state.datasetBriefs);

  return useMemo(() => {
    if (!datasetId) return false;

    const brief = datasetBriefs.find(
      (brief: IDatasetBrief) => brief.id === datasetId
    );

    return brief?.isFWE;
  }, [datasetId, datasetBriefs]);
};
